import { render, staticRenderFns } from "./TasksTable.container.vue?vue&type=template&id=161da018&scoped=true&"
import script from "./TasksTable.container.vue?vue&type=script&lang=js&"
export * from "./TasksTable.container.vue?vue&type=script&lang=js&"
import style0 from "./TasksTable.container.vue?vue&type=style&index=0&id=161da018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161da018",
  null
  
)

export default component.exports